"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _wdh = require("@demant/wdh");

var _index = require("../pim/index");

var _configLoader = _interopRequireDefault(require("./configLoader"));

var _PEPConfig = _interopRequireDefault(require("./PEPConfig"));

var _PEPFilter = require("./PEPFilter");

var _PEPLabels = _interopRequireDefault(require("./PEPLabels"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

var PEPComponent = /*#__PURE__*/function (_WDHComponent) {
  _inherits(PEPComponent, _WDHComponent);

  var _super = _createSuper(PEPComponent);

  /**
   * @callback PEPComponent~resolveProductId
   * @param {HTMLElement} component
   * @returns {string}
   */

  /**
   * Base component for all PEP components. Handles parsing configuration and initializing load of data. Don't use directly, but rather one of it's subclasses.
   * @param {string} selector
   * @augments WDHComponent
   * @constructor
   * @inheritdoc
   */
  function PEPComponent() {
    var _this;

    var selector = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'pep';
    var directPimProducts = arguments.length > 1 ? arguments[1] : undefined;

    _classCallCheck(this, PEPComponent);

    _this = _super.call(this, selector, directPimProducts);
    _this.directPimProducts = directPimProducts || null;
    /**
     * @type {PEPConfig}
     * @private
     */

    _this.config = null;
    /**
     * @callback PEPComponent~renderCallback
     * @param {Object}                  response
     * @param {HTMLElement}             response.component The current instance of the component
     * @param {PIM}                     response.pimInstance The global PIM instance used for loading data
     * @param {Promise<PIMData|Error>}  response.dataPromise A promise for the data being loaded.
     * @param {PEPFilter[]}             response.filters An array of filters configured for component
     * @param {PEPConfig}               response.config The full configuration parsed for the component
     * @param {PEPLabels}               response.labels An instance of PEPLabels used for retrieving labels for the ui.
     */

    /**
     * Called when the component has been initialized and started loading data
     * @type {PEPComponent~renderCallback}
     */

    _this.onRender = null;
    return _this;
  }

  _createClass(PEPComponent, [{
    key: "init",
    value: function init(component) {
      var _this2 = this;

      this.config = (0, _configLoader["default"])(component, this.config);
      var pim = new _index.PIM(this.config.pim, this.config.data, this.directPimProducts);
      var dataPromise = new Promise(function (resolve, reject) {
        if (_this2.directPimProducts || _this2.config.data) {
          var pimData = pim.getData();

          _this2.postProcessPIMData(pimData);

          resolve(pimData);
        } else {
          _this2.fetchData(pim, component).then(function (pimData) {
            _this2.postProcessPIMData(pimData);

            resolve(pimData);
          })["catch"](function (err) {
            reject(err);
          });
        }
      });

      if (this.onRender) {
        this.onRender({
          component: component,
          pim: pim,
          dataPromise: dataPromise,
          filters: this.getFilters(),
          config: this.config,
          labels: new _PEPLabels["default"](component)
        });
      }
    }
    /**
     * @param {PIM} pim
     * @param {HTMLElement} component
     * @protected
     */

  }, {
    key: "fetchData",
    value: function fetchData(pim) {
      // eslint-disable-line no-unused-vars
      return new Promise();
    }
    /**
     * @returns {PEPFilter[]}
     * @private
     */

  }, {
    key: "getFilters",
    value: function getFilters() {
      return [];
    }
    /**
     * @param {PIMData} pimData
     * @returns {PIMData}
     * @private
     */

  }, {
    key: "postProcessPIMData",
    value: function postProcessPIMData(pimData) {
      return pimData;
    }
  }, {
    key: "decorateFiltersWithProductIDs",
    value: function decorateFiltersWithProductIDs(pimData) {
      var filters = this.getFilters();
      var products = pimData.getProducts();
      filters.forEach(function (filter) {
        filter.values.forEach(function (filterValue) {
          filterValue.productIDs = [];
          products.forEach(function (product) {
            if (pimData.filterMatches(product, filter.property, filterValue.value)) {
              filterValue.productIDs.push(product.productId);
            }
          });
        });
      });
    }
    /**
     * @param {PIMData} pimData
     * @param {PEPFilter[]} filters
     * @private
     */

  }, {
    key: "createFilters",
    value: function createFilters(pimData, filters) {
      var _this3 = this;

      filters.forEach(function (filter) {
        if (filter.values.length === 0) {
          _this3.autoFillFilterValues(pimData, filter);
        }

        pimData.createFilter(filter.property, filter.isInclusive, filter.values);
        var emptyValueIndexes = [];
        filter.values.forEach(function (filterValue, index) {
          if (filterValue.isSelected) pimData.setFilter(filter.property, filterValue.value);

          if (pimData.getNumberOfProductsForFilter(filter.property, filterValue.value) === 0) {
            emptyValueIndexes.push(index);
            pimData.unsetFilter(filter.property, filterValue.value);
          }
        });
        emptyValueIndexes.reverse().forEach(function (index) {
          filter.values.splice(index, 1);
        });
      });
    }
  }, {
    key: "autoFillFilterValues",
    value: function autoFillFilterValues(pimData, filter) {
      var newValues = [];
      var newFiltersList = {};
      pimData.products.forEach(function (product) {
        var productValue = product[filter.property];

        if (!newFiltersList[productValue]) {
          newFiltersList[productValue] = {};
          newFiltersList[productValue].label = productValue;
          newFiltersList[productValue].value = productValue;
          newFiltersList[productValue].isSelected = false;
          newFiltersList[productValue].productIDs = [];
        }
      });
      Object.keys(newFiltersList).map(function (key) {
        return newValues.push(newFiltersList[key]);
      });
      filter.values = newValues;
    }
  }]);

  return PEPComponent;
}(_wdh.WDHComponent);

var _default = PEPComponent;
exports["default"] = _default;